<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pt-3 pt-md-7">
        </base-header>     
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-1 ">
              <base-button type="primary" icon="ni ni-bold-left" @click="pre"></base-button>
            </div>
            <div class="col-md-10">
            <!--Tables-->
              <div class="row">
                <div class="col mt-2">
                  <page-visits-table title="Cổng" :proctors="proclayer1" :shiftID="shift._id" :shiftDate="shift.createdAt" :endDate="new Date(shift.endDate)" :beginDate="new Date(shift.beginDate)" layer=1 @update-proctor="updateproctor" @cancel-proctor="deleteproctor"></page-visits-table>
                </div>
              </div>
              <div class="row">
                <div class="col mt-2">
                  <page-visits-table title="Lễ Tân" :proctors="proclayer2"  :shiftID="shift._id" :shiftDate="shift.createdAt" :endDate="new Date(shift.endDate)" layer=2 @update-proctor="updateproctor"  @cancel-proctor="deleteproctor"></page-visits-table>
                </div>
              </div>
              <div class="row">
                <div class="col mt-2">
                  <page-visits-table title="NOC" :proctors="proclayer3" :shiftID="shift._id" :shiftDate="shift.createdAt" :endDate="new Date(shift.endDate)" layer=3 @update-proctor="updateproctor"  @cancel-proctor="deleteproctor"></page-visits-table>
                </div>
              </div>
            </div>
            <div class="col-md-1">
              <base-button type="primary" icon="ni ni-bold-right" @click="next"></base-button>
            </div>
            <!--End tables-->

          </div>
        </div>

    </div>
</template>
<script>
  // Tables
  import PageVisitsTable from './Dashboard/PageVisitsTable';
  import _ from 'lodash'
  export default {
    components: {
      PageVisitsTable,
    },
    
    data() {
      return {
        position: 0,
        shift: '',
        proctors: [],
        result: {}
      }
    },
    methods: {
      next() {
        this.position -= 1
        this.getshift()
      },
      pre() {
        this.position += 1
        this.getshift()
      },
      async getshift() {
        let res = ''
        if (this.location =='NTMK') {
          res = await this.$http.get('/ntmk/cur',{params:{"position":this.position}})
        } else if (this.location =='TTN') {
          res = await this.$http.get('/ttn/cur', {params:{"position":this.position}})
        }
        else {
          res = await this.$http.get('/dbp/cur', {params:{"position":this.position}})
        }
        this.shift = res.data
        this.proctors = this.shift.proctors
      },
      formattime(curdate) {
        if(curdate){
          return this.$moment.tz(curdate,"Asia/Ho_Chi_Minh").format("DD/MM/YYYY HH:mm")
        }
        
      },
      updateproctor(proctor) {
        let exist_proctor = this.proctors.filter(element => { return element.userid === proctor.userid  })
        if(exist_proctor) {
          this.proctors =  _.without(this.proctors, exist_proctor[0])
        }
          this.proctors.push(proctor)
        
      },
      deleteproctor() {
        let obj =  this.proctors.filter(proctor => { return proctor.userid === this.$store.state.user._id})
        this.proctors =  _.without(this.proctors, obj[0])
      }
   
    },
    computed: {
      location() {
        return this.$store.getters.curlocation
      },
      proclayer1() {
        return this.proctors.filter(proctor => { return proctor.layer == 1})
      },
      proclayer2() {
        return this.proctors.filter(proctor => { return proctor.layer == 2})
      },
      proclayer3() {
        return this.proctors.filter(proctor => { return proctor.layer == 3 })
      }   
    }
    ,
    mounted() {
      this.getshift()
    },
    created() {
    }
  }
</script>
<style></style>
